export function LoadingSpinner({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="loading-wrap">
      <div className="loading-spinner" role="status" aria-label={label} />
    </div>
  );
}
